import getStore from '../store';

export default function getAllScenarioIds(): string[] {
    const scenarioIds = [];
    [...getStore().scenarios.keys()].forEach(key => {
        // only return the keys that have an intialized scenario
        if (getStore().scenarios.get(key)) {
            scenarioIds.push(key);
        }
    });
    return scenarioIds;
}
